import { GIT_TOOL_NAMES } from "./git-tool-names-constants";

// The opening of a real success: packages/tasks/src/lib/git/git-commit.ts, branch/push-branch.ts and repo/rebind/settle-primary-checkout.ts.
export const GIT_SUCCESS_PREFIX: Readonly<Record<string, string>> = {
  [GIT_TOOL_NAMES.GIT_COMMIT]: "Committed",
  [GIT_TOOL_NAMES.GIT_PUSH]: "Pushed to",
  [GIT_TOOL_NAMES.REBIND_REPO]: "Switched to",
};
